@if (tourService.isActive()) {
  <div class="tour-root" role="dialog" aria-modal="true" aria-live="polite">
    <div class="tour-backdrop"></div>

    <div
      class="tour-highlight"
      [style.top.px]="highlight.top"
      [style.left.px]="highlight.left"
      [style.width.px]="highlight.width"
      [style.height.px]="highlight.height">
    </div>

  <div
    class="tour-tooltip"
    [class.is-top]="tooltip.placement === 'top'"
    [class.is-bottom]="tooltip.placement === 'bottom'"
    [class.is-left]="tooltip.placement === 'left'"
    [class.is-right]="tooltip.placement === 'right'"
    [style.top.px]="tooltip.top"
    [style.left.px]="tooltip.left">

    @if (tourService.currentStep(); as step) {
      <div class="tour-tooltip-header">
        <span class="tour-step-count">
          Step {{ tourService.currentStepIndex() + 1 }} of {{ tourService.stepCount() }}
        </span>
        <button type="button" class="tour-skip-btn" (click)="skip()">Skip tour</button>
      </div>

      <h3 class="tour-title">{{ step.title }}</h3>
      <p class="tour-body">{{ step.body }}</p>

      @if (anchorMissing) {
        <p class="tour-missing">This step target is not visible on the current screen. Continue to the next tip.</p>
      }

      <div class="tour-actions">
        <button
          type="button"
          class="tour-btn tour-btn-secondary"
          [disabled]="tourService.isFirstStep()"
          (click)="previous()">
          Back
        </button>
        <button type="button" class="tour-btn tour-btn-primary" (click)="next()">
          {{ tourService.isLastStep() ? 'Finish' : 'Next' }}
        </button>
      </div>
    }
  </div>
  </div>
}
